import React from 'react';
import { Box } from '../../../../../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../../../../../CommonComponents/OPL/Text/Text';
import { MARKET_CONDITIONS } from '../../../../tabs/MonteCarlo/MonteCarlo.meta';

export const MethodologyTooltip = (
  <Box p="4" maxWidth="360px">
    <Text fontSize="small" fontWeight={600} color="white" mb="8">
      Market Scenarios Methodology
    </Text>
    <Text fontSize="small" color="white" mb="8">
      Market Scenarios project portfolio outcomes under a range of market conditions. Results come
      from Monte Carlo simulations that model possible market paths, using historical performance,
      risk, and correlation across asset classes. Users can configure the number of trials (between
      250 and 1,000), and the displayed results reflect the trial count selected.
    </Text>
    <Text fontSize="small" color="white" mb="12">
      Each scenario shown is a percentile rank drawn from the full set of simulated trials. Each
      curve is built year by year — for any given year, the curve shows that year's percentile
      across all trials, but the curve does not represent a single trial's journey through time.
    </Text>
    <Text fontSize="small" fontWeight={600} color="white" mb="4">
      Scenario Definitions
    </Text>
    {MARKET_CONDITIONS.map(({ category, header, description }) => (
      <Box key={category} mb="4">
        <Text fontSize="small" fontWeight={600} color="white">
          {header}:&nbsp;
          <Text as="span" fontSize="small" color="white" fontWeight={400}>
            {description}
          </Text>
        </Text>
      </Box>
    ))}
  </Box>
);
